module.exports = __webpack_public_path__ + "static/headline.9e918993.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/headline.jpg
// module id = 476
// module chunks = 114276838955818